export const hasOnlyMailroomScopes = (
  tokenScopeItem?: Utils.ArrayElement<
    Api.Response['describeAccessToken']['tokenScopeList']
  >,
) => {
  if (!tokenScopeItem) return false;
  const { org, scope, user } = tokenScopeItem;

  const mailroomScopes = [
    `o${org?.id}-parcelMgmtParcels:r`,
    `o${org?.id}-parcelMgmtParcels:w`,
  ];

  const userScope = `user${user?.id}`;

  const filteredScopes = scope?.filter(
    (scopeItem) => !scopeItem.includes(userScope),
  );

  return (
    filteredScopes?.length! > 0 &&
    filteredScopes?.every((scopeItem) => mailroomScopes.includes(scopeItem))
  );
};
